(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('applicationSharedDataField', ApplicationSharedDataField)

    /** @ngInject */
    function ApplicationSharedDataField($filter, $rootScope, LoadingHelper, SharedDataService, PATHS_FRANCHISER) {
        function ApplicationSharedDataController() {
            const vm = this;

            vm.addApplicationSharedData = () => {
                vm.amountOfRegisters++;
            }

            vm.removeApplicationSharedData = index => {
                vm.applicationSharedData.splice(index, 1);

                vm.amountOfRegisters--;
            }

            vm.getNumber = num => {
                let retArray = [];

                for (let i = 0; i < num; i++)
                    retArray.push(i);

                return retArray;
            }

            vm.isTypeDisabled = (type, indexOwner) => {
                return type.disabled && type.indexOwner != indexOwner;
            }

            vm.onChangeType = (selectedType, indexOwner) => {
                if (!selectedType || isNaN(indexOwner)) return;

                vm.sharedDataTypes.forEach(type => {
                    let isTypeSelected = vm.applicationSharedData.find(applicationSD => {
                        if (type.Id == applicationSD.SharedDataId)
                            return applicationSD;
                    })

                    if (isTypeSelected && !type.disabled) {
                        type.disabled = true;
                        type.indexOwner = indexOwner;
                    } else if (!isTypeSelected && !type.disabled) {
                        type.disabled = false;
                        type.indexOwner = null;
                    } else if (!isTypeSelected && type.disabled) {
                        type.disabled = false;
                        type.indexOwner = null;
                    }
                })
            }

            vm.getSharedData = () => {
                LoadingHelper.startLoading('.document-container', true);

                return SharedDataService
                    .getAll()
                    .then(success => {
                        vm.sharedDataTypes = $filter('orderBy')(success, 'Description', false);;
                        LoadingHelper.stopLoading('.document-container')
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.document-container')
                    })
            }

            init();

            function init() {
                vm.sharedDataTypes = [];
                vm.getValidationMessage = $rootScope.ValidationMessage;
            }
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.getSharedData()
                .then(() => {
                    ctrl.amountOfRegisters = 1;

                    if (ctrl.applicationSharedData && ctrl.applicationSharedData.length) {
                        ctrl.amountOfRegisters = ctrl.applicationSharedData.length;

                        for (let index = 0; index < ctrl.applicationSharedData.length; index++) {
                            const applicationSD = ctrl.applicationSharedData[index];
                            let sharedData = ctrl.sharedDataTypes.find(type => (type.Id == applicationSD.SharedDataId));

                            if (sharedData) {
                                sharedData.disabled = true;
                                sharedData.indexOwner = index;
                            }
                        }

                        if (ctrl.amountOfRegisters == 0)
                            ctrl.amountOfRegisters = 1;
                    } else {
                        ctrl.applicationSharedData = [];
                    }
                })
        }

        return {
            bindToController: true,
            controller: ApplicationSharedDataController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/directives/application-shared-data-field/application-shared-data-field.html`,
            scope: {
                applicationSharedData: '=',
                canEdit: '=',
                applicationBaseUrl: '='
            }
        }
    }
}());